import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import services from "../services";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import Joi from "@hapi/joi";
import { activeSupplierCountReportSchemaObject } from "../activeSupplierCountReportSchema";
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import xlsx from 'json-as-xlsx';
import _, { map, set } from 'lodash';
import $ from 'jquery';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';
import { makeStyles } from '@material-ui/core/styles';

const screenCode = "ACTIVESUPPLIERCOUNTREPORT";
const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
    dialog1: {
        width: 850,
    }
});
export function ActiveSupplierCountReport(props) {

    const componentRef = useRef();
    const classes = useStyles();
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(0);
    const [reportData, setReportData] = useState([]);
    const [groups, setGroups] = useState([]);
    const [factories, setFactories] = useState([]);
    const [routes, setRoutes] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);

    const [totalActive, setTotalActive] = useState(0);
    const [totalInActive, setTotalInActive] = useState(0);
    const [finalTotal, setFinalTotal] = useState(0);



    const [accountSupplierCount, setAccountSupplierCount] = useState({
        groupID: "0",
        factoryID: "0",
        routeID: "0"
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        factory: "0",
        route: "0"
    });

    const [errors, setErrors] = useState({});

    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    const schema = Joi.object(activeSupplierCountReportSchemaObject).options({ allowUnknown: true });

    const [contentRowNames, setContentRowNames] = useState(["collectionPointName", "isActive"]);

    const [csvHeaders, setCsvHeaders] = useState([]);
    const [csvData, setCsvData] = useState([]);

    const handleLimitChange = (event) => {
        setLimit(event.target.value);
    };
    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };
    useEffect(() => {
        createDataTable();
        trackPromise(getPermissions(),
            getGroupsForDropdown()
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getFactoriesForDropdown(),
        )
    }, [accountSupplierCount.groupID])

    useEffect(() => {
        trackPromise(
            getRoutesForDropDown()
        )
    }, [accountSupplierCount.factoryID])

    function handleGroupChange(target) {
        validateInputs(target);

        setAccountSupplierCount({
            ...accountSupplierCount,
            groupID: target.value,
            factoryID: "0",
            routeID: "0"

        });
        setIsTableHide(true);
    }

    function handleFactoryChange(target) {
        validateInputs(target);

        setAccountSupplierCount({
            ...accountSupplierCount,
            factoryID: target.value,
            routeID: "0"
        });
        setIsTableHide(true);
    }

    function handleRouteChange(target) {
        validateInputs(target);

        setAccountSupplierCount({
            ...accountSupplierCount,
            routeID: target.value,
        });
        setIsTableHide(true);
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, activeSupplierCountReportSchemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }


    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWACTIVESUPPLIERCOUNTREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');


        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });
        var token = tokenService.getUserDetailsFromToken();

        setAccountSupplierCount({
            ...accountSupplierCount,
            groupID: token.groupID,
            factoryID: token.operationEntityID
        });
        trackPromise(getGroupsForDropdown());
    }


    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getFactoriesForDropdown() {
        const data = await services.getFactoriesByGroupID(accountSupplierCount.groupID);
        setFactories(data);
    }

    async function getRoutesForDropDown() {
        const data = await services.getAllRoutesByFactoryID(accountSupplierCount.factoryID);
        setRoutes(data);
    }


    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }

    async function handleSearch(e) {
        e.preventDefault();
        

        const errorMessages = validate(schema, accountSupplierCount);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;
        getSelectedDropdownValuesForReport(accountSupplierCount);
        var res = await services.getActiveSupplierCountData(accountSupplierCount);
         
        if (res != null || res.length != 0) {

            let lemp2 = _.groupBy(res, 'collectionPointName')
            const finalResult = Object.values(lemp2)

            finalResult.forEach(x => {
                let activeCount = 0;
                let inActiveCount = 0;

                x.forEach(y => {
                    if (y.isActive == true) {
                        activeCount = activeCount + 1;
                    }
                    else {
                        inActiveCount = inActiveCount + 1;
                    }
                    x.active = activeCount;
                    x.inActive = inActiveCount;
                    x.total = activeCount + inActiveCount;
                    x.collectionPointName = y.collectionPointName;
                });

                var totalActive = 0;
                var totalInActive = 0;
                var finalTotal = 0;
                finalResult.forEach(x => {
                    totalActive = totalActive + x.active;
                    totalInActive = totalInActive + x.inActive;
                    finalTotal = finalTotal + x.total;
                });
                setTotalActive(totalActive);
                setTotalInActive(totalInActive);
                setFinalTotal(finalTotal);

            });

            const excelData = [
                { label: "Route Name", value: "collectionPointName"},
                { label: "Active", value: "active" },
                { label: "InActive", value: "inActive" },
                { label: "Total", value: "total" }
        
            ]

            setCsvHeaders(excelData);
            destroyDataTable();
            setReportData(finalResult);
            setCsvData(finalResult);
            setIsTableHide(false);
            createDataTable();
            
        }

    }

    function destroyDataTable() {
        $('#example').DataTable().destroy();
    }

    function createDataTable() {
        $('#example').DataTable({
            "order": [[0, "asc"]]
        });
    }

    function createFile() {
        var settings = {
            sheetName: ("Active Supplier Count Report"),
            fileName: ("Active Supplier Count Report" + ' ' + new Date().toLocaleString()),
            writeOptions: {}
        }

        var copyOfCsv = [...csvData]

        var newRow1 = {
            collectionPointName: "Total",
            active : totalActive,
            inActive: totalInActive,
            total : finalTotal
        }
        var newRow2 = {
            collectionPointName: "Group :" + selectedSearchValues.group,
            active: "Factory : " + selectedSearchValues.factory,
            inActive: "Collection Point: " + (selectedSearchValues.route === undefined ? "All Collection Points" : selectedSearchValues.route)
        }
        var newRow3 = {
            collectionPointName: "Generated date/time : " + new Date().toLocaleString()
       }
        copyOfCsv.push(newRow1)
        copyOfCsv.push({},newRow2)
        copyOfCsv.push(newRow3)
        xlsx(csvHeaders, copyOfCsv, settings, true)
    }

    function onCancelClick() {
        clearState();
    }

    function clearState() {
        setAccountSupplierCount({
            ...accountSupplierCount,
            routeID: "0",
            date: ""
        });
        setIsTableHide(true);
        setErrors("");
    }


    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            factory: factories[searchForm.factoryID],
            route: routes[searchForm.routeID],
            date: searchForm.date
        })
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <PageHeader
                            title="Active Supplier Count Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                                disabled={false}
                            >
                                <div className="form-group row">

                                    <div className="col-md pb-1">

                                        <InputLabel shrink id="groupID">Group *</InputLabel>

                                        <Select
                                            fullWidth
                                            id="groupID"
                                            name="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            value={accountSupplierCount.groupID}
                                            onChange={(e) => handleGroupChange(e.target)}>
                                            <MenuItem value="0">--Select Group Name--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>

                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="factoryID">Factory *</InputLabel>
                                        <Select fullWidth
                                            id="factoryID"
                                            name="factoryID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            value={accountSupplierCount.factoryID}
                                            onChange={(e) => handleFactoryChange(e.target)}>
                                            <MenuItem value="0">--Select Factory--</MenuItem>
                                            {generateDropDownMenu(factories)}
                                        </Select>
                                        {errors["factoryID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["factoryID"]}</FormHelperText>}

                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="">Collection Point</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="routeID"
                                            id="routeID"
                                            name="routeID"
                                            value={accountSupplierCount.routeID}
                                            onChange={(e) => handleRouteChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Collection Point--</MenuItem>
                                            {generateDropDownMenu(routes)}
                                        </Select>
                                        {errors["routeID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["routeID"]}</FormHelperText>)}
                                    </div>

                                </div>

                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, accountSupplierCount)}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />

                                    <input type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Cancel"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </form>

                            { reportData.length != 0 ?
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="table-responsive row-top-gap">

                                            <TableContainer component={Paper}>
                                                <Table className={classes.table} aria-label="simple table">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell align="left" style={{ fontWeight: "bold" }}>Route Name</TableCell>
                                                            <TableCell align="right" style={{ fontWeight: "bold" }}>Active</TableCell>
                                                            <TableCell align="right" style={{ fontWeight: "bold" }}>InActive</TableCell>
                                                            <TableCell align="right" style={{ fontWeight: "bold" }}>Total</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {reportData.slice(page * limit, page * limit + limit).map((row, i) => (
                                                            <TableRow key={i}>
                                                                <TableCell component="th" scope="row" align="left"> {row[0].collectionPointName}</TableCell>
                                                                <TableCell component="th" scope="row" align="right"> {row.active}</TableCell>
                                                                <TableCell component="th" scope="row" align="right"> {row.inActive}</TableCell>
                                                                <TableCell component="th" scope="row" align="right"> {row.total}</TableCell>

                                                            </TableRow>

                                                        )
                                                        )}

                                                    </TableBody>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell align="left" style={{ fontWeight: "bold" }}>Total</TableCell>
                                                            <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}> {totalActive}</TableCell>
                                                            <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}> {totalInActive}</TableCell>
                                                            <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}> {finalTotal}</TableCell>
                                                        </TableRow>

                                                    </TableHead>

                                                </Table>
                                                <TablePagination
                                                    component="div"
                                                    count={reportData.length}
                                                    onChangePage={handlePageChange}
                                                    onChangeRowsPerPage={handleLimitChange}
                                                    page={page}
                                                    rowsPerPage={limit}
                                                    rowsPerPageOptions={[5, 10, 25]}
                                                />
                                            </TableContainer>

                                        </div>
                                    </div>
                                </div>
                           : null }


                            <br />
                            <br />
                            <br />
                            { reportData.length != 0 ?
                                <div>
                                    <div className="pt-4">
                                        <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Excel"
                                            onClick={createFile}
                                        />

                                        <ReactToPrint
                                            documentTitle={"Active Supplier Count Report"}
                                            trigger={() => <input
                                                type="submit"
                                                className="btn btn-primary pull-right ml-2"
                                                value="PDF"

                                            />}
                                            content={() => componentRef.current}
                                        />

                                    </div>
                                    <div hidden={true}>
                                        <CreatePdf ref={componentRef} data={reportData}
                                            rowNames={contentRowNames} searchData={selectedSearchValues}
                                            totalActive={totalActive} totalInActive={totalInActive} finalTotal={finalTotal}
                                        />
                                    </div>
                                </div>
                           :null }
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
